export default __webpack_public_path__ + "a7176158eebe9296b4a9427fadd8451a.png";